<template>
  <div class="md-layout md-size-40 md-medium-size-60 md-xsmall-size-100 p-0">
    <div class="md-layout-item md-size-50">
      <v-select :class="{ 'hide-clear-btn': hideClearButton }" label="name" :placeholder="Year" v-model="year" :options="years" @input="$emit('setYear', $event)"></v-select>
    </div>
    <div class="md-layout-item md-size-50">
      <v-select :class="{ 'hide-clear-btn': hideClearButton }" label="name" :placeholder="Month" v-model="month" :options="months" @input="$emit('setMonth', $event)"></v-select>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MonthPicker',
  props: {
    hideClearButton: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      monthsData: [
        { number: 1, name: "Jan", days: '31' },
        { number: 2, name: "Feb", days: '28' },
        { number: 3, name: "Mar", days: '31' },
        { number: 4, name: "Apr", days: '30' },
        { number: 5, name: "May", days: '31' },
        { number: 6, name: "Jun", days: '30' },
        { number: 7, name: "Jul", days: '31' },
        { number: 8, name: "Aug", days: '31' },
        { number: 9, name: "Sep", days: '30' },
        { number: 10, name: "Oct", days: '31' },
        { number: 11, name: "Nov", days: '30' },
        { number: 12, name: "Dec", days: '31' }
      ],
      month: { number: null, name: "", days: "" },
      year: "",
      // year: {
      //   name: '',
      //   value: ''
      // },
      Month: "Month",
      Year: "Year",
      getSignUpYear: null,
      getSignUpMonth: null
    };
  },
  mounted() {
    const currentDate = new Date();
    // this.year.name = `${currentDate.getFullYear()}`;
    // this.year.value = currentDate.getFullYear();
    this.year = currentDate.getFullYear();
    this.month.number = currentDate.getMonth() + 1;
    // this.month.days = new Date(this.year.value, this.month.number, 0).getDate();
    this.month.days = new Date(this.year, this.month.number, 0).getDate();
    const monthVal = currentDate.toLocaleString("default", {
      month: "2-digit"
    });
    this.month.name = currentDate.toLocaleString("default", { month: "long" });
    this.$emit("setYear", this.year);
    this.$emit("setMonth", this.month);
  },
  computed: {
    years() {
      const current_year = new Date().getFullYear();
      const year = 2021;
      var arr = [];
      for (var i = year; i <= current_year; i++) {
        arr.push(i);
      }
      return arr;
    },
    months() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      var monthsJson = [];
      if (this.year === currentYear) {
        const currentMonth = currentDate.getMonth() + 1;
        for (var i = 0; i < currentMonth; i++) {
          monthsJson.push(this.monthsData[i]);
        }
        return monthsJson;
      } else {
        for (var i = 0; i < 12; i++) {
          monthsJson.push(this.monthsData[i]);
        }
        return monthsJson;
      }
    }
  },
  methods: {}
};
</script>

<style scoped>
.vs__clear {
  display: none;
}
</style>
<style>
.hide-clear-btn .vs__clear {
  display: none !important;
}
</style>
